export const menuType = {
  proposal: 'mock-proposal',
  proposalFilter6: 'mock-proposal-filter-6',
  proposalFilterOther: 'mock-proposal-filter-other',
  review: 'mock-reveiw',
  directorApporveReviewer: 'mock-directorApporveReviewer',
  reviewer: 'mock-reviewer',
  projectManagement: 'mock-projectManagement',
  //projectManagement: '50CB2F7F-B273-414E-8282-2C779C1E689B',
  //projectManagement: 'F08C927F-2F81-40A8-B673-3DE67648C379', // สำหรับ test สำนัก 6
  projectManagementReview: 'mock-projectManagement-review',

  contract: 'mock-contract',
  //contract: 'BAB78D89-6CF1-4479-9210-A8C331B057C7',

  centerContract: 'mock-centerContract',
  //centerContract: 'BAB78D89-6CF1-4479-9210-A8C331B057C7',

  staffContract: 'mock-staffContract',
  //staffContract: 'BAB78D89-6CF1-4479-9210-A8C331B057C7',

  directorContract: 'mock-directorContract',
  //directorContract: '3319AEBD-D584-429E-88DE-A2CEFDADE01C',
  //directorContract: '455C132E-4F2D-4398-A843-FDF85CA8FA2A',

  managerContract: 'mock-managerContract',
  //managerContract: '3319AEBD-D584-429E-88DE-A2CEFDADE01C',

  approve: 'mock-approve',
  waitApproval: 'mock-wait-approve',
  withdrawRequest: 'mock-withdraw-request',
  notAccepted: 'mock-not-accepted',
  reviweMulti: 'multi-reveiw',
  approveMulti: 'multi-approve',
  setting: 'setting',
  report: 'report',
  search: 'search',
  // subProject: 'mock-subProject',
  subProject: '24563D5E-DD4A-4C7C-9506-340FF142D664',
  subProjectReport: 'subproject',
  auditSchema: 'auditSchema',
  reviewPayment: 'reviewPayment',
  // law: 'mock-lawdepartment',
  incomeAndExpense: 'mock-incomeAndExpense',
}

const SUB_PROJECT_PROPOSAL = '/subproject/proposal'
const SUB_PROJECT_REVIEW = '/subproject/review'
const SUB_PROJECT_PROPOSAL_SETTING = '/setting/subproject/proposal'

export default {
  logon: '/logon',
  thangrathLanding: '/thangrath-landing',
  renderimg: '/show-img',
  dashboardRoot: '/dashboard',
  dashboardRootSetting: '/dashboard-setting',
  dashboardNew: '/dashboard-new',
  proposalRoot: '/proposal',
  echarts: '/echarts',
  disclaim: '/disclaim',
  formDownloads: '/form-downloads',
  manageInviteProject: '/manage-invite-project',
  manageConsiderationRound: '/manage-consideration-round',
  redirectLink: '/redirect-link',
  thaID: {
    authen: '/thaid-authen',
    callback: '/thaid-callback',
  },
  setting: {
    dashboardSetting: '/setting/dashboard',
  },
  proposal: {
    overview: {
      overviewCoworker: '/proposal/overview/overview-coworker',
      submit: '/proposal/overview/submit',
      submitEdit: '/proposal/overview/submit-edit',
      summaryReviseRequest: '/proposal/summary-revise-request', //สรุปความเห็นให้ปรับปรุงแก้ไข
    },
    assessment: {
      assessmentOfWorkingWithThaiHealth: '/proposal/assessment-of-working-with-thaiHealth',
      assessmentMAndEForm: '/assessment/m-and-e-form',
      assessmentPrePostTest: '/assessment/pre-post-test',
      dashboard: '/assessment/dashboard',
    },
    review: {
      proposalFilterHistory: '/proposal/review/proposal-filter-history',
      proposalFilter6: '/proposal/review/proposal-filter-6',
      proposalFilter: '/proposal/review/proposal-filter',
      strategic: '/proposal/review/strategic',
      outcomeIndicator: '/proposal/review/outcome-indicator',
      paymentPlanSave: '/proposal/review/payment-plan-save',
      scrutinizeMethodSingle: '/proposal/review/scrutinize-method',
      meetingSummarySingle: '/proposal/review/meeting-summary',
      paymentSave: '/proposal/review/payment-save',
      assign: '/proposal/review/assign',
      mittingAssign: '/proposal/review/assign-mitting',
      sendAssign: '/proposal/review/send-assign',
      attendanceRecord: '/proposal/review/attendance-record',
      reviewSummary: '/proposal/review/review-summary',
      reviewSummaryAttachFileCoi: '/proposal/review/attach-file',
      reviewSummaryPaper: '/proposal/review/review-summary-paper',
      proposalRevise: '/proposal/review/proposal-revise', //ขั้นที่ 4 ส่งกลับผู้ขอรับทุนเพื่อปรับปรุงข้อเสนอโครงการ
      proposalReviseRequest: '/proposal/review/proposal-revise-request',
      approveReviewerRevise: '/proposal/review/approve-reviewer-revise', //ส่งกลับผู้ขอรับทุนเพื่อปรับปรุงข้อเสนอโครงการ

      approveProposal: '/proposal/review/approve-proposal',
      approveReviewer: '/proposal/review/approve-reviewer',
      approveReviewerMulti: '/proposal/review/approve-reviewer-multi',
      paymentCheckForReviewer: '/proposal/review/payment-check/for-reviewer',
      paymentCheckForDirector: '/proposal/review/payment-check/for-director',
      granteeProfileInfoForReviewer: '/proposal/review/grantee-profile-info-for-reviewer',
      granteeProfileInfoForDirector: '/proposal/review/grantee-profile-info-for-director',
      approveProject: '/proposal/review/approve-project',
      projectList: '/proposal/review/project-list',
      strategicMulti: '/proposal/review/multi-strategic',
      paymentSaveMulti: '/proposal/review/multi-payment-save',
      scrutinizeMethodMuti: '/proposal/review/multi-scrutinize-method',
      meetingSummaryMulti: '/proposal/review/multi-meeting-summary',
      assignMulti: '/proposal/review/multi-assign',
      mittingAssignMulti: '/proposal/review/multi-assign-mitting',
      sendAssignMulti: '/proposal/review/multi-send-assign',
      reviewSummaryMulti: '/proposal/review/multi-review-summary',
      reviewResultMulti: '/proposal/review/multi-review-results',
      paymentPlanSaveMulti: '/proposal/review/multi-payment-plan-save',
      attendanceRecordMulti: '/proposal/review/multi-attendance-record',
      reviewListMulti: '/proposal/review/multi-review-list',

      paymentCheckMulti: '/proposal/review/multi-payment-check',
      ProposeConsiderApproveProjectMulti: '/proposal/review/multi-propose-consider-approve-project',
    },
    proposalRevisionHistory: '/proposal/proposal-revision-history',
    selectProposalForm: '/proposal/select-proposal-form',
    selectProposalFormDep6: '/proposal/select-proposal-form-deprtment-6',
    projectTypeInfo: '/proposal/project-type-info',
    projectName: '/proposal/project-name',
    goal: '/proposal/goal',
    targetSetting: '/proposal/target-setting',
    granteeProperty: '/proposal/grantee-property',
    workingGroup: '/proposal/working-group',
    backgroundAndImportant: '/proposal/background-and-important',
    objectiveGoal: '/proposal/objective-goal',
    activityAndResult: '/proposal/activity-and-result',
    budget: '/proposal/budget',
    projectManagementStructure: '/proposal/project-management-structure',
    monitoringAndInternalEvaluation: '/proposal/monitoring-and-internal-evaluation',
    expectedResult: '/proposal/expected-result',
    stepAndPhase: '/proposal/step-and-phase',
    granteeBasicInfo: '/proposal/grantee-basic-info',
    responsibleManBasicInfo: '/proposal/responsible-man-basic-info',
    attachFiles: '/proposal/attach-files',
    allAttachFiles: '/proposal/all-attach-files',
    attachFilesPDPA: '/proposal/attach-files-pdpa',
    disclaim: '/proposal/disclaim',
    sumamaryProposalFilter: '/proposal/summary-proposal-filter',
    personalDataProtectionAct: '/proposal/personal-data-protection-act',
    setting: {
      settingReviewer: '/proposal/setting/setting-reviewer',
      settingDirector: '/proposal/setting/setting-director',
      settingPermission: '/proposal/setting/permission',
      settingRole: '/proposal/setting/role',
      settingRolePermission: '/proposal/setting/manage-role-permission',
      settingTemplateProject: '/proposal/setting/template-project-proposal',
      settingFormRecipient: '/proposal/setting/setting-form-recipient',
      settingFormGeneral: '/proposal/setting/setting-form-general',
      settingFormProject: '/proposal/setting/setting-form-project',
      settingFormPlanSummary: '/proposal/setting/setting-form-plan-summary',
    },
    projectManagement: {
      paymentReceipt: '/proposal/project-management/paymentReceipt',
      progressReport: '/proposal/project-management/progress-report',
      withdrawRequest: '/proposal/project-management/withdraw-request',
      sendWithdrawRequest: '/proposal/project-management/send-withdraw-request',
      approveWithdraw: '/proposal/project-management/approve-withdraw',
      editPaymentPlan: '/proposal/project-management/edit-payment-plan',
      intellectualProperty: '/proposal/project-management/intellectual-property-report',
    },
    projectEvaluation: '/proposal/project-evaluation-view-coworker',
    projectEvaluationProgress: '/proposal/project-evaluation-progress',
    projectEvaluationRelation: '/proposal/project-evaluation-relation',
    endOfProject: '/proposal/end-of-project',
    endOfProjectApprove: '/proposal/end-of-project-approve',
    closeOfProject: '/proposal/close-of-project',
    closeOfProjectAfterClosed: '/proposal/close-of-project-after-closed',
    closeOfProjectStaff: '/proposal/close-of-project-staff',
    closeOfProjectApprove: '/proposal/close-of-project-approve',
    coworkerDisclaimProject: '/proposal/coworker-disclaim-of-Project',
    staffDisclaimProject: '/proposal/staff-disclaim-of-Project',
    directorDisclaimProject: '/proposal/director-disclaim-of-Project',
    staffSuspendProject: '/proposal/staff-suspend-of-Project',
    directorSuspendProject: '/proposal/director-suspend-of-Project',
    staffCancelSuspendProject: '/proposal/staff-cancel-suspend-of-Project',
    directorCancelSuspendProject: '/proposal/director-cancel-suspend-of-Project',
    staffCancelProject: '/proposal/staff-cancel-of-Project',
    lawyerCancelProject: '/proposal/lawyer-cancel-of-Project',
    directorCancelProject: '/proposal/director-cancel-of-Project',
    highDirectorCancelProject: '/proposal/high-director-cancel-of-Project',
    previewBeforePrint: '/proposal/preview-before-print',
    inviteToProject: '/proposal/invite-to-project',
    inviteToProjectAcceptance: '/proposal/invite-to-project/acceptance',
    contract: {
      makeContract: '/proposal/contract/make',
      makeContractChangeWithdrawPerson: '/proposal/contract/make/change-withdraw-person',
      makeContractChangeWithdrawPersonStaff: '/proposal/contract/make/change-withdraw-person/staff',
      makeContractChangeWithdrawPersonApprover: '/proposal/contract/make/change-withdraw-person/approver',
      makeContractChangeWithdrawPersonContractCenter: '/proposal/contract/make/change-withdraw-person/contract-center',
      notMakeContract: '/proposal/contract/not-make',
      AgreementAdditionalView: '/proposal/contract/add-agreement',
      editContractView: '/proposal/contract/edit-contract',
      coworkerSignatory: '/proposal/contract/coworker-signatory',
      addAttachmentsContract: '/proposal/contract/add-attachments',
      checkFundRecipients: '/proposal/contract/staff-step1-check-fund-recipients',
      checkContractAttachments: '/proposal/contract/staff-step2-check-contract-attachments',
      offerAuthorizedSignatoryStaff:
        '/proposal/contract/staff-step3-offer-authorized-signatory-staff',
      contractSigning: '/proposal/contract/contract-signing',
      summaryProjectApprovalSenceStaff: '/proposal/contract/summary-project-approval-sence-staff',
      moreRequest: '/proposal/contract/more-request',
      requestNotMakeContract: '/proposal/contract/request-not-make-contract',
      uncertified: '/proposal/contract/uncertified',
      moreRequestStaffEdit: '/proposal/contract/more-request-staff-edit',
      staffSendApproveBankAccount: '/proposal/contract/staff-send-approve-bank-account',
      centerCheckFundRecipients: '/proposal/contract/contract-center-step1-check-fund-recipients',
      centerCheckContractAttachments:
        '/proposal/contract/contract-center-step2-check-contract-attachments',
      centerOfferAuthorizedSignatory:
        '/proposal/contract/contract-center-step3-offer-authorized-signatory',
      centerRequestNotMakeContract: '/proposal/contract/contract-center-request-not-make-contract',
      centerAddBankAccount: '/proposal/contract/contract-center-add-bank-account',
      centerSubmitContract: '/proposal/contract/contract-center-submit-contract',
      directorCheckFundRecipients: '/proposal/contract/director-step1-check-fund-recipients',
      directorCheckContractAttachments:
        '/proposal/contract/director-step2-check-contract-attachments',
      directorOfferAuthorizedSignatory:
        '/proposal/contract/director-step3-offer-authorized-signatory',
      directorRequestNotMakeContract: '/proposal/contract/director-request-not-make-contract',
      directorMoreRequest: '/proposal/contract/director-more-request',
      directorUncertified: '/proposal/contract/director-uncertified',
      directorApproveBankAccount: '/proposal/contract/director-approve-bank-account',
      directorMoreRequestEdit: '/proposal/contract/director-more-request-edit',
      managerCheckFundRecipients: '/proposal/contract/manager-step1-check-fund-recipients',
      managerCheckContractAttachments:
        '/proposal/contract/manager-step2-check-contract-attachments',
      managerOfferAuthorizedSignatory:
        '/proposal/contract/manager-step3-offer-authorized-signatory',
      managerRequestNotMakeContract: '/proposal/contract/manager-request-not-make-contract',
      managerUncertified: '/proposal/contract/manager-uncertified',
      reSendFile: '/proposal/contract/resend-file',
      contractChangeForm: '/proposal/contract/change/form',
      contractChangeFormHistory: '/proposal/contract/change/form/history',
      contractChangeExtendPeriodForm: '/proposal/contract/change/extend-period/form',
      contractChangeExtendPeriodList: '/proposal/contract/change/extend-period',
    },
    approve: {
      paymentCheck: '/proposal/review/payment-check',
      granteeForStaff: '/proposal/review/grantee-for-staff',
      ProposeConsiderApproveProject: '/proposal/review/propose-consider-approve-project',
      projectApprovalSummaryForStaff: '/proposal/review/project-approval-summary',
      contractCenterCommentBeforeApprove: '/proposal/review/contract-center-comment-before-approve',
      sentToFix: '/proposal/review/sent-to-fix', //ขั้นที่ 4 ส่งกลับเพื่อแก้ไข
      StaffHistoryReviewApprove: '/proposal/staff/history-review/approve',

      projectApprove: '/proposal/approval/project-approve',
      paymentApprove: '/proposal/progress/payment-approve',
      closeApprove: '/proposal/progress/close-approve',
      modifyContractApprove: '/proposal/contract/modify-contract-approve',
      TerminateApprove: '/proposal/progress/terminate-approve',

      approveProjectMulti: '/proposal/approve/multi-approve-project/approve',
      notApproveProjectMulti: '/proposal/approve/multi-approve-project/not-approve',
      approveContractMulti: '/proposal/approve/multi-edit-contract/approve',
      notApproveContractMulti: '/proposal/approve/multi-edit-contract/not-approve',
      approveDisbursementMulti: '/proposal/approve/multi-disbursement/approve',
      notApproveDisbursementMulti: '/proposal/approve/multi-disbursement/not-approve',
      approveClosureMulti: '/proposal/approve/multi-closure/approve',
      notApproveClosureMulti: '/proposal/approve/multi-closure/not-approve',
      approveTerminateMulti: '/proposal/approve/multi-terminate/approve',
      notApproveTerminateMulti: '/proposal/approve/multi-terminate/not-approve',
      approveCancelMulti: '/proposal/approve/multi-cancel/approve',
      notApproveCancelMulti: '/proposal/approve/multi-cancel/not-approve',
    },
    notaccepted: {
      reviewNotaccepted: '/proposal/overview/review-notaccepted',
      reviewSend: '/proposal/overview/review-send',
    },
  },
  subProject: {
    subProjectDashboard: '/proposal-subproject',
    // subProjectPage: '/proposal-subproject',
    overviewSubProject: '/proposal-subproject/overview/overview-subproject',
    subProjectTypeInfo: '/proposal-subproject/subproject-type-info',
    targetSettingSubProject: '/proposal-subproject/target-setting-subproject',
    subProjectName: '/proposal-subproject/subproject-name',
    objectiveGoalSub: '/proposal-subproject/objective-goal',
    budgetSubProject: '/proposal-subproject/budget',
    granteeBasicInfoSub: '/proposal-subproject/grantee-basic-info',
    responsibleManBasicInfoSub: '/proposal-subproject/responsible-man-basic-info',
    closeProject: '/proposal-subproject/close-project',
    saveProgressive: '/proposal-subproject/save-progressive',
    changeSubProjectStatus: '/proposal-subproject/change-project-status',
    reviewSubproject: {
      saveReviewSubproject: '/proposal-subproject/overview/save-review-subproject',
      assignExpertSub: '/proposal-subproject/overview/assign-expert-subproject',
      reviewSummarySub: '/proposal-subproject/overview/review-summary-subproject',
      proposalReviseSub: '/proposal-subproject/overview/proposal-revise-subproject',
      paymentSaveSub: '/proposal-subproject/overview/payment-save-subproject',
    },
    approve: {
      paymentCheckSubproject: '/proposal-subproject/review/payment-check-subproject',
      granteeForStaffSubproject: '/proposal-subproject/review/grantee-for-staff-subproject',
      // ProposeConsiderApproveProject: '/proposal/review/propose-consider-approve-project',
      subProjectApprovalSummaryForStaff: '/proposal-subproject/review/subproject-approval-summary',
      sentToFixSubproject: '/proposal-subproject/review/sent-to-fix-subproject',
      // StaffHistoryReviewApprove: '/proposal/staff/history-review/approve',
    },
    projectManagement: {
      // paymentReceipt: '/proposal/project-management/paymentReceipt',
      progressReportSubproject: '/proposal-subproject/project-management/progress-report',
      progressReportSubprojectClose:
        '/proposal-subproject/project-management/progress-report-close',
      // withdrawRequest: '/proposal/project-management/withdraw-request',
      // sendWithdrawRequest: '/proposal/project-management/send-withdraw-request',
      // approveWithdraw: '/proposal/project-management/approve-withdraw',
      periodicFinancialReport: '/proposal-subproject/project-management/periodic-financial-report',
      periodicFinancialReportClose:
        '/proposal-subproject/project-management/periodic-financial-report-close',
    },
    withdraw: {
      // paymentReceipt: '/proposal/project-management/paymentReceipt',
      withdrawRequestSubproject: '/proposal-subproject/withdraw/withdraw-request-subproject',
    },
    contract: '/proposal-subproject/contract',
    setting: {
      reportSetting: '/proposal-subproject/report-setting',
      manageUserGroups: '/proposal-subproject/manage-user-groups',
      manageUserRole: '/proposal-subproject/manage-user-role',
      manageEvaluationTeamRole: '/proposal-subproject/manage-evaluation-team-role',
      importUserRole: '/proposal-subproject/import-user-role',
    },
    report: {
      approvalFormReport: '/proposal-subproject/report/approval-form-report',
      summaryReport: '/proposal-subproject/report/summary-report',
      grantReport: '/proposal-subproject/report/grant-report',
      billPaymentReport: '/proposal-subproject/report/bill-payment-report',
      subProjectApprovalReport: '/proposal-subproject/report/subproject-approval-report',
      progressiveReport: '/proposal-subproject/report/subproject-progressive-report',
      projectControlReport: '/proposal-subproject/report/subproject-project-control-report',
      subProjectReport: '/proposal-subproject/report/subproject-report',
      installmentReport: '/proposal-subproject/report/installment-report',
    },
    users: {
      usersRole: '/proposal-subproject/setting/users-role',
      createUser: '/proposal-subproject/setting/users-create',
    },
    searchSubproject: '/proposal-subproject/search-subproject',
    projectMonitorRecord: '/proposal-subproject/project-monitor-record',
    projectInfoDoc: '/proposal-subproject/project-info-doc',
    SearchForNames: '/proposal-subproject/search-for-names',
    projectIndicators: '/proposal-subproject/project-indicators',
    projectIndicatorsDetails: '/proposal-subproject/project-indicators/details',
    trackingHistory: '/proposal-subproject/tracking-history',
    projectMonitorRecordFollow: '/proposal-subproject/project-monitor-record-follow',
    checkProjectQuality: '/proposal-subproject/check-project-quality',
    projectCommentsRecord: '/proposal-subproject/project-comments-record',
  },
  admin: {
    adminReport: {
      ProjectInfoAccordingReviewCycle: '/admin/project-info-according-review-cycle',
      PreApprovedProject: '/admin/pre-approved-project',
      ApprovedProject: '/admin/approved-project',
      ProjectActiveSeparateIssues: '/admin/project-active-separate-issues',
      ProjectChangedStatusProcess: '/admin/project-changed-status-process',
      ContractCenterProjectTracking: '/admin/contract-center-project-tracking',
      ProjectTracking: '/admin/project-tracking',
      ProjectClosedLate: '/admin/project-closed-late',
      ProjectDisbursementByPeriod: '/admin/project-disbursement-by-period',
      SubProjectReportAdmin: '/admin/sub-project-report',
      DocumentDeliveryAddress: '/admin/document-delivery-address',
      ProjectApproved: '/admin/project-approved',
      ActiveProjectForContract: '/admin/active-project-for-contract',
      ProjectWaitingForClose: '/admin/project-waiting-for-close',
      ProjectClose: '/admin/project-close',
      ProjectGrant: '/admin/project-grant',
      OverduePaymentPeriod: '/admin/overdue-paymen-period',
      ObligationOfInstallment: '/admin/obligation-of-installment',
      Obligation: '/admin/obligation',
      BudgetApprovalReport: '/admin/budget-approval-report',
      ConfirmActualResult: '/admin/confirm-actual-result',
      ProjectBudgetPlanReport: '/admin/project-budget-plan-report',
      AccessLoggerActivity: '/admin/access-logger-activity-report',

      AllProjectSummaryReport: '/admin/AllProjectSummaryReport',
      SummaryTraceProjectStatusBeforeAfterContractRepor:
        '/admin/SummaryTraceProjectStatusBeforeAfterContractRepor',
      ProjectApprovalReport: '/admin/ProjectApprovalReport',
      MonthlyDisbursementTargetReport: '/admin/MonthlyDisbursementTargetReport',
      OverdueOweReport: '/admin/OverdueOweReport',
      OverdueDebtByMonthReport: '/admin/OverdueDebtByMonthReport',
      OverdueDebtByOfficeReport: '/admin/OverdueDebtByOfficeReport',
      ShowingPaymentReport: '/admin/ShowingPaymentReport',
      ContractCenterProjectTrackingReport: '/admin/ContractCenterProjectTrackingReport',
      DelayedCloseProjectReport: '/admin/DelayedCloseProjectReport',
      BurdenBindingInstallmentReport: '/admin/BurdenBindingInstallmentReport',
      BurdenBindingReport: '/admin/BurdenBindingReport',
      BudgetDisbursementInClosedProjectsReport: '/admin/BudgetDisbursementInClosedProjectsReport',
      AiEvaluationReport: '/report/proposal-evaluation-report',

      OverallBudgetReport: '/admin/overall-budget-report', //รายงานภาพรวมการเบิกจ่าย

      ExtentionTimePerProjectReport: '/admin/extention-time-perproject-report',
      ExtentionTimePerPeriodReport: '/admin/extention-time-perperiod-report',
      ExtentionTimeOverviewReport: '/admin/extention-time-overview-report',
      OverallDisbursementReport: '/admin/overall-disbursement-report',
    },
    adminManage: {
      ManageProjectStatus: '/admin/ManageProjectStatus',
      ManageProjectCoordinator: '/admin/manageProjectCoordinator',
      ManageCorporateAndOfficeInformation: '/admin/ManageCorporateAndOfficeInformation',
      ManageAuthorityApproveProject: '/admin/ManageAuthorityApproveProject',
      ManageProjectConsiderationRound: '/admin/ManageProjectConsiderationRound',
      ManageProhibited: '/admin/ManageProhibited',
      ManageCommitteeAccounts: '/admin/ManageCommitteeAccounts',
      ManageExpertAccounts: '/admin/ManageExpertAccounts',
      ManageExpertScrutinizeOnline: '/admin/ManageExpertScrutinizeOnline',
      ManageProjectClosedLate: '/admin/ManageProjectClosedLate',
      ManageLawProjectTracking: '/admin/ManageLawProjectTracking',
      ManageMasterDataPreName: '/admin/manage-master-data/prename',
      ManageMasterDataSetting: '/admin/manage-master-data/setting',
      ManageMasterDataTarget: '/admin/manage-master-data/target',
      ManageMasterDataIssue: '/admin/manage-master-data/issue',
      ManageMasterDataLawType: '/admin/manage-master-data/law-type',
      ManageMasterDataLawStatus: '/admin/manage-master-data/law-status',
      ManageMasterDataLocationType: '/admin/manage-master-data/location-type',
      ManageMasterDataThaihealthPlan: '/admin/manage-master-data/thaihealth-plan',
      ManagePermissions: '/admin/manage-permissions',
      ManageNotificationElse: '/manage-notification/else',
      ManageNotificationAsset: '/manage-notification/assets',
      ManageHoliday: '/admin/manage-holiday',

      // settingReviewer :'/proposal/setting/setting-reviewer',
      // '/proposal/setting/setting-director',
      settingAuthorizeApproveCapital: '/proposal/setting/setting-Authorize-Approve-Capital',
      SettingPermission: '/proposal/setting/permission',
      SettingRole: '/proposal/setting/role',
      SettingRoleAndPermission: '/proposal/setting/manage-role-permission',
      TemplateProjectProposal: '/proposal/setting/template-project-proposal',
      SettingScreeningConditions: '/proposal/setting/screening-conditions',
    },
    adminSetting: {
      SettingPermissionUser: '/admin/SettingPermissionUser',
      SettingNotifications: '/admin/SettingNotifications',
      SettingDurationPreferences: '/admin/SettingDurationPreferences',
    },
    adminWithdrawalReview: {
      sendWithdrawReview: '/admin/sendWithdrawReview',
      withdrawReview: '/admin/withdrawReview', //approve withdraw review
      sendWithdrawReviewByReviewer: '/admin/sendWithdrawReviewByReviewer',
      withdrawReviewByReviewer: '/admin/withdrawReviewByReviewer', //approve withdraw review by reviewer
    },
  },
  law: {
    ManageLegal: '/law/legal-management',
    TrackingHistoryLaw: '/law/tracking-history-law',
    SaveLawList: '/law/save-law-list',
    SaveLawTracking: '/law/save-law-tracking',
    CallBookNotice: '/law/call-book-notice',
    CheckNotice: '/law/check-notice',
    DocumentOfTermination: '/law/document-of-termination',
    LawDocumentform: '/law/law-document-form',
    LawApprove: '/law/law-approve',
  },
  search: {
    ManageExpertAccountsViewOnly: '/search/manage-expert-accounts-view-only',
    ProposalAllDetail: '/search/proposal-all-detail',
    ProjectGranteeBasicInfo: '/search/project-grantee-basic-info',
    AddEvaluationPage: '/search/add-evaluation-page',
    AddEvaluationType: '/search/add-evaluation-type',
    AddEvaluationForm: '/search/add-evaluation-form',
    EvaluationForm: '/search/evaluation-form',
    CheckApproval: '/search/check-approval',
    ProjectVenderLists: '/search/project-vender-list',
    AiEvaluationReport: '/search/proposal-evaluation-report',
  },
  SearchExpertPayment: '/search-expert-payment',
  incomeAndExpense: {
    MainIncomAndExpense: '/income-and-expense/main',
    MainApprover: '/income-and-expense/main-approver',
    // MainAuditDepartment: '/income-and-expense/main-audit',
    //MainIncomAndExpenseStaff: '/income-and-expense/main-staff',
    ProjectBasedItems: '/income-and-expense/project-based-item',
    IncomeRecord: '/income-and-expense/income-record',
    ExpenseRecord: '/income-and-expense/expense-record',
    StrategyRegister: '/income-and-expense/strategy-register',
    ManageSubStrategy: '/income-and-expense/manage-sub-strategy',
    // UpdateList: '/income-and-expense/update-list',
    ManageBankAccount: '/income-and-expense/manage-bank-account',
    //PaymentRecordAdvance: '/income-and-expense/payment-record-advance',
    //AdvanceRefund: '/income-and-expense/advance-refund',
    CreatePayeeAndTaxInfo: '/income-and-expense/create-payee-and-tax-info',
    DailyPayBook: '/income-and-expense/daily-pay-book',
    PeriodicManagement: '/income-and-expense/periodic-management',
    VoucherList: '/income-and-expense/voucher-list',
    report: {
      FinancialReportsDelivered: '/income-and-expense/report/financial-reports-delivered',
      BorrowAdvanceReport: '/income-and-expense/borrow-avance/borrow-report',
      SubprojecteReport: '/income-and-expense/report/subproject',
      Cash: '/income-and-expense/report/cash',
      Deposit: '/income-and-expense/report/deposit',
      TaxSumReport: '/income-and-expense/report/tax-summary-report',
    },

    BorrowAvanceVoucherList: '/income-and-expense/borrow-avance/voucher-list',
    BorrowAdvancePaymentRecord: '/income-and-expense/borrow-avance/payment-record-advance',
    BorrowAdvanceRefund: '/income-and-expense/borrow-avance/advance-refund',

    UpdateList: '/income-and-expense/update-list/record',
    UpdateListVoucherList: '/income-and-expense/update-list/voucher-list',

    SubProjectMainIncomAndExpense: '/income-and-expense/sub-project/main',
    SubProjectProjectBasedItems: '/income-and-expense/sub-project/project-based-item',
    SubProjectVoucherList: '/income-and-expense/sub-project/voucher-list',
    SubProjectExpenseRecord: '/income-and-expense/sub-project/expense-record',
    SubProjectIncomeRecord: '/income-and-expense/sub-project/income-record',

    ExpenseCheckManage: '/expense/check/manage',
    ExpenseCheckList: '/expense/check/voucher-list',
    eFillingListForm: '/income-and-expense/e-filling-list-form', //นำเข้าข้อมูลยื่น eFilling
    ViewFileseFilling: '/income-and-expense/view-files-e-filling', //ดูไฟล์แนบ eFilling
    eFillingListReport: '/income-and-expense/e-filling-list-report', //รายงาน eFilling
    eFillingSummaryReport: '/income-and-expense/e-filling-summary-report', //สรุปภาษี(รายปี)
    AnnualTaxRemittance: '/income-and-expense/annual-tax-remittance', //นำส่งภาษีรายปี

    eFillingListFormApprover: '/income-and-expense/e-filling-list-form-approver', //นำเข้าข้อมูลยื่น eFilling สำหรับผู้บริหาร
    eFillingListReportApprover: '/income-and-expense/e-filling-list-report-approver', //รายงาน eFilling สำหรับผู้บริหาร
    eFillingSummaryReportApprover: '/income-and-expense/e-filling-summary-report-approver', //สรุปภาษี(รายปี) สำหรับผู้บริหาร
    AnnualTaxRemittanceApprover: '/income-and-expense/annual-tax-remittance-approver', //นำส่งภาษีรายปี สำหรับผู้บริหาร

  },
  durableArticles: {
    AddDurableArticles: '/durable-articles/add',
    DurableArticlesHistory: '/durable-articles/history',
    ListDurableArticles: '/durable-articles/list',
    ClosureDurableArticles: '/durable-articles/closure',
    ManageDurableArticles: '/durable-articles/manage-durable-articles',
    //ApprovalCloseProject: '/durable-articles/approval-close-project',
    AssetCounting: '/durable-articles/asset-counting',
    AddAssetCounting: '/durable-articles/add-asset-counting',
    MigrationDurableArticles: '/durable-articles/migration',

    // จนท พัสดุ
    AssetCountingSupplyOfficer: '/durable-articles/asset-counting-supply-officer',
    AddAssetCountingSupplyOfficer: '/durable-articles/add-asset-counting-supply-officer',

    ClosureApproveRequest1: '/durable-articles/closure-approve-request-step-1',
    ClosureApproval1: '/durable-articles/closure-approval-step-1',
    ClosureApproveRequest2: '/durable-articles/closure-approve-request-step-2',
    ClosureApproval2: '/durable-articles/closure-approval-step-2',

    BookingManagementScholars: '/durable-articles/booking-management-scholars',
    AssetQrCodeReport: '/durable-articles/asset-create-qr-report',
    AssetRegisterReport: '/durable-articles/asset-register-report',
    AssetStatusReport: '/durable-articles/asset-status-report',
    ApproverAssetRegisterReport: '/durable-articles/approver/asset-register-report',
    ApproverAssetStatusReport: '/durable-articles/approver/asset-status-report',

    AssetSendBackEditLists: '/durable-articles/asset-send-back-edit-lists',

    AssetBookingManagement: '/durable-articles/asset-booking-management', //นวชก จัดการการจอง
    AssetBookingManagementDetail: '/durable-articles/asset-booking-management/detail', //นวชก จัดการการจอง

    AssetBookingManagementOfficer: '/durable-articles/asset-booking-management-officer', //จนท พัสดุ จัดการรายการขอจองครุภัณฑ์
    AssetBookingManagementDetailOfficer:
      '/durable-articles/asset-booking-management-officer/detail', //จนท พัสดุ จัดการรายการขอจองครุภัณฑ์

    AssetBookingLists: '/durable-articles/asset-booking-lists', //นวชก รายการครุภัณฑ์จองแล้ว

    AssetRequestManagement: '/durable-articles/asset-request-management', //นวชก จัดการการขอใช้งาน
    AssetRequestManagementDetail: '/durable-articles/asset-request-management/detail', //นวชก จัดการการขอใช้งานครุภัณฑ์

    AssetRequestManagementApprove: '/durable-articles/asset-request-management/approve', //ผอ. อนุมัติขอใช้งานครุภัณฑ์
    ListOfAssetsOfficer: '/durable-articles/list-of-assets/circulatory', //รายการครุภัณฑ์ ส่วนของขอใช้งานครุภัณฑ์
    ListOfAssets: '/durable-articles/list-of-assets', //รายการครุภัณฑ์
    // NotificationOfAssets: '/durable-articles/notification-of-assets', //แจ้งเตือนครุภัณฑ์
    ListDepreciationAssets: '/durable-articles/list-depreciation-assets', //รายงานครุภัณฑ์ค่าเสื่อม

    ManageAssetRevolving: '/durable-articles/manage-asset-revolving',
  },

  financialManagement: {
    FinancialManagement: '/financial-management/main',
  },
  subProjectList: '/sub-project-list-page',
  audit: {
    ReportsAudit: '/audit/reports-audit',
    AuditFileImport: '/audit/import-file',
    AuditImportGrade: '/audit/import-grade',
    FollowAuditIssues: '/audit/follow-audit-issues',
    AuditReportSummary: '/audit/audit-report-summary',
    DirectorFollowAuditIssues: '/audit/director-follow-audit-issues',
    PrepareProjectReview: '/audit/prepare-project-review',
    AuditDashboard: '/audit/audit-dashboard',
    ListReportIssues: '/audit/list-report-issues',
    FundManagerAuditIssues: '/audit/fund-manager-audit-issues',
    AuditDucumentManagement: '/audit/document-management',
    AuditEmailAttManagement: '/audit/email-attachments-management',
    AuditEmailAttManagement: '/audit/email-attachments-management',
  },
  blacklist: {
    Blacklisted: '/blacklist/list-blacklisted',
    AddBlacklist: '/blacklist/add-blacklist',
  },
  evaluates: {
    CoworkerEvaluateThaihealth: '/evaluates/coworker-evaluate-thaihealth',
    CoworkerEvaluateYourself: '/evaluates/coworker-evaluate-yourself',
    CoordinatorEvaluateCoworker: '/evaluates/coordinator-evaluate-coworker',
    DirectorEvaluateCloseProject: '/evaluates/director-evaluate-close-project',
  },
  infoma: {
    InfomaUploadFiles: '/infoma/infoma-upload-files',
  },
  // กรอกข้อมูล
  subProjectNew: {
    overview: '/subproject/overview/overview-subproject',
    proposalSubmit: '/subproject/proposal-submit',
    proposal: {
      projectName: `${SUB_PROJECT_PROPOSAL}/projectName`, //1.  จัดการ Templete
      projectProponent: `${SUB_PROJECT_PROPOSAL}/projectProponent`, //2.  ผู้เสนอโครงการ
      projectResponsibler: `${SUB_PROJECT_PROPOSAL}/projectResponsibler`, //3. ผู้รับผิดชอบโครงการ
      projectCoMaker: `${SUB_PROJECT_PROPOSAL}/projectCoMaker`, //4.ผู้ร่วมทำโครงการ
      projectCoMaker2: `${SUB_PROJECT_PROPOSAL}/projectCoMaker2`, //4.ผู้ร่วมทำโครงการ
      projectFeature: `${SUB_PROJECT_PROPOSAL}/projectFeature`, // 5.คุณสมบัติพื้นฐานและลักษณะต้องห้ามผู้เสนอโครงการ
      projectBackground: `${SUB_PROJECT_PROPOSAL}/projectBackground`, //6. ความเป็นมา/ หลักการและเหตุผล/ ความสำคัญของปัญหา
      projectGoal: `${SUB_PROJECT_PROPOSAL}/projectGoal`, //6-Nomarl. ความสอดคล้องของโครงการ กับเป้าหมายเชิงยุทธศาสาตร์ 10 ปี
      projectObjectiveOutcomeIndicator: `${SUB_PROJECT_PROPOSAL}/projectObjective-outcome-indicator`, //7.  วัตถุประสงค์ ผลลัพธ์และตัวชี้วัด
      targetOperationArea: `${SUB_PROJECT_PROPOSAL}/targetOperationArea`, //8.  กลุ่มเป้าหมายและพื้นที่ดำเนินการ
      operatingPeriod: `${SUB_PROJECT_PROPOSAL}/operatingPeriod`, //9.  ระยะเวลาดำเนินงาน
      activities: `${SUB_PROJECT_PROPOSAL}/activities`, // 10.  กิจกรรมการดำเนินงาน/แผนการดำเนินงาน
      otherSupport: `${SUB_PROJECT_PROPOSAL}/otherSupport`, //11. กรณีที่มีการสนับสนุนทรัพยากรจากหน่วยงานอื่น
      resultsReport: `${SUB_PROJECT_PROPOSAL}/resultsReport`, //12.  วิธีรายงานผลลัพธ์ของโครงการ
      partner: `${SUB_PROJECT_PROPOSAL}/partner`, //13.  องค์กรภาคีที่ร่วมดำเนินงาน
      expectedResult: `${SUB_PROJECT_PROPOSAL}/expected-result`, //13.1. ผลที่คาดว่าจะได้รับ
      attachments: `${SUB_PROJECT_PROPOSAL}/attachments`, //14. เอกสารแนบท้ายโครงการ
      appendix: `${SUB_PROJECT_PROPOSAL}/appendix`, //15. ภาคผนวก
    },
    review: {
      paymentSave: `${SUB_PROJECT_REVIEW}/payment-save`, //บันทึกงวดเงิน
      reviewSave: `${SUB_PROJECT_REVIEW}/review-save`, //บันทึกผลการพิจารณากลั่นกรอง และสรุปผล
    },
    //ทำสัญญา
    contract: '/subproject/contract',

    // ตั้งค่า templete
    settingProposal: {
      templeteManage: `/manage/subproject/proposal/templete`, // จัดการ Templete(หน้าหลัก)
      templeteDetail: `/setting/subproject/templete`, //1.  จัดการ Templete
      projectName: `${SUB_PROJECT_PROPOSAL_SETTING}/projectName`, //1.  ชื่อโครงการ mock
      projectProponent: `${SUB_PROJECT_PROPOSAL_SETTING}/projectProponent`, //2.  ผู้เสนอโครงการ mock
      projectResponsibler: `${SUB_PROJECT_PROPOSAL_SETTING}/projectResponsibler`, //3. ผู้รับผิดชอบโครงการ mock
      projectCoMaker: `${SUB_PROJECT_PROPOSAL_SETTING}/projectCoMaker`, //4.ผู้ร่วมทำโครงการ mock
      projectFeature: `${SUB_PROJECT_PROPOSAL_SETTING}/projectFeature`, // 5.คุณสมบัติพื้นฐานและลักษณะต้องห้ามผู้เสนอโครงการ mock
      projectBackground: `${SUB_PROJECT_PROPOSAL_SETTING}/projectBackground`, //6. ความเป็นมา/ หลักการและเหตุผล/ ความสำคัญของปัญหา mock
      projectObjectiveOutcomeIndicator: `${SUB_PROJECT_PROPOSAL_SETTING}/projectObjective-outcome-indicator`, //7.  วัตถุประสงค์ ผลลัพธ์และตัวชี้วัด mock
      targetOperationArea: `${SUB_PROJECT_PROPOSAL_SETTING}/targetOperationArea`, //8.  กลุ่มเป้าหมายและพื้นที่ดำเนินการ mock
      operatingPeriod: `${SUB_PROJECT_PROPOSAL_SETTING}/operatingPeriod`, //9.  ระยะเวลาดำเนินงาน mock
      activities: `${SUB_PROJECT_PROPOSAL_SETTING}/activities`, // 10.  กิจกรรมการดำเนินงาน/แผนการดำเนินงาน mock
      otherSupport: `${SUB_PROJECT_PROPOSAL_SETTING}/otherSupport`, //11. กรณีที่มีการสนับสนุนทรัพยากรจากหน่วยงานอื่น mock
      resultsReport: `${SUB_PROJECT_PROPOSAL_SETTING}/resultsReport`, //12.  วิธีรายงานผลลัพธ์ของโครงการ mock
      partner: `${SUB_PROJECT_PROPOSAL_SETTING}/partner`, //13.  องค์กรภาคีที่ร่วมดำเนินงาน mock
      attachments: `${SUB_PROJECT_PROPOSAL_SETTING}/attachments`, //14. เอกสารแนบท้ายโครงการ mock
      appendix: `${SUB_PROJECT_PROPOSAL_SETTING}/appendix`, //15. ภาคผนวก mock
    },
    subProjectListSratusReport: '/sub-project/list/status-report',
  },
  assessment: {
    assessmentSettingPage: '/assessment/setting/add-evaluation-page',
    assessmentSettingType: '/assessment/setting/add-evaluation-type',
    assessmentSettingAddForm: '/assessment/setting/add-evaluation-form',
    assessmentSettingForm: '/assessment/setting/evaluation-form',
    assessmentSettingMasterQuestion: '/assessment/setting/master-question',

    assessmentSettingManageUnitType: '/assessment/setting/manage-unit-type',

    assessmentMAndE: '/assessment/m-and-e',
    assessmentMAndEForm: '/assessment/m-and-e/form',
    assessmentMAndESelf: '/assessment/m-and-e-self',
    assessmentMAndESelfList: '/assessment/m-and-e-self/list',
    assessmentMAndESelfInputForm: '/assessment/m-and-e-self/input-form',
    assessmentMAndESelfForm: '/assessment/m-and-e-self/form',
    assessmentPrePostTest: '/assessment/pre-post-test',
    assessmentPrePostTestPreview: '/assessment/pre-post-test/preView',
    assessmentMAndEManageCBTeam: '/assessment/m-and-e/manage-cb-team',
    assessmentReportPartnerStrength: '/assessment/report/partner-strength',
    assessmentReprotProjectManagement: '/assessment/report/project-management',
    assessmentReprotHealthPromotionProject: '/assessment/report/health-promotion-project',
    assessmentReprotCompetenciesAssessment: '/assessment/report/competencies-assessment',
    assessmentReprotCompetenciesPartner: '/assessment/report/competencies-partner',
    assessmentReprotUnitCompetency: '/assessment/report/unit-competency',
    assessmentReprotEvaluationScore: '/assessment/report/evaluation-score',

    assessmentImportNodeData: '/assessment/import/node-data',
  },
  ProjectBudgetReport: '/project-budget-report',
  ProjectContractReport: '/project-contract-report',
}
